import { useState, useEffect } from 'react'

const STORAGE_KEY = 'alrtz_cookie_consent'

export default function CookieConsent() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      // Small delay so it doesn't flash on page load
      const t = setTimeout(() => setShow(true), 1500)
      return () => clearTimeout(t)
    }
  }, [])

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true')
    setShow(false)
  }

  if (!show) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9990] p-3 md:p-4 animate-slide-up">
      <div className="max-w-lg mx-auto bg-surface border border-border px-4 py-3 flex items-center justify-between gap-4">
        <p className="text-white text-xs leading-relaxed">
          We use essential cookies for authentication. No tracking cookies.
        </p>
        <button
          onClick={dismiss}
          className="shrink-0 text-xs font-semibold text-brand hover:text-brand-light transition-colors px-3 py-1 border border-brand/30 hover:border-brand/50"
        >
          Got it
        </button>
      </div>
    </div>
  )
}
